import { FC } from 'react';
import { css } from '@emotion/react';
import { spacing, colors } from '../../../styles';
import { ToolRendererProps } from './types';

export const PeersRenderer: FC<ToolRendererProps> = ({ output, isLoading }) => {
  if (isLoading) {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${colors.silver};
        `}
      >
        Finding peers...
      </div>
    );
  }

  const content = typeof output === 'string' ? output : output.content || '';
  const peers = content.match(/[A-Z]{1,5}/g) || [];

  if (peers.length > 0) {
    return (
      <div
        css={css`
          margin: ${spacing.centi} 0 0 0;
        `}
      >
        <div
          css={css`
            font-size: 12px;
            color: ${colors.silver};
            margin-bottom: ${spacing.centi};
          `}
        >
          Found {peers.length} peer companies
        </div>
        <div
          css={css`
            display: flex;
            flex-wrap: wrap;
            gap: ${spacing.centi};
          `}
        >
          {peers.slice(0, 6).map((peer: string, index: number) => (
            <span
              key={index}
              css={css`
                font-size: 14px;
                color: ${colors.petrolBlue};
                font-weight: 500;

                html[data-theme='dark'] & {
                  color: ${colors.skyBlue};
                }
              `}
            >
              {peer}
            </span>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div
      css={css`
        font-size: 14px;
        color: ${colors.silver};
      `}
    >
      Peer analysis completed
    </div>
  );
};
